/** A status word for the Delivery console's screens: a tone with its icon, as every status is (never colour alone). */
import type { ReactNode } from 'react';
import { CheckCircle2, CircleDashed, Info, ShieldCheck, XCircle } from 'lucide-react';
import { StatusBadge, type Tone } from '../../ui/primitives';

const TONE_ICON = { accepted: CheckCircle2, queued: CircleDashed, refused: XCircle, info: Info, admin: ShieldCheck, neutral: CircleDashed } as const;

export function Tag({ tone, children, title }: { tone: Tone; children: ReactNode; title?: string }) {
  return <StatusBadge tone={tone} icon={TONE_ICON[tone]} title={title}>{children}</StatusBadge>;
}
